import { Component, Input } from '@angular/core';
import { TableColumnComponent } from '../table-column/table-column.component';
import { TableSelectionModel } from '../../../../../app/api/data-sources/table-selection-model';

@Component({
    selector: 'app-column-checkbox',
    templateUrl: './column-checkbox.component.html',
    styleUrls: ['./column-checkbox.component.scss'],
    standalone: false,
})
export class ColumnCheckboxComponent extends TableColumnComponent {
    @Input() public selection: TableSelectionModel<any>;
    @Input() public columnKeyName = 'select';
}
